/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ProcessSecurityModel {
        public securityMatricies: Wars.Domain.Model.SecurityMatrix[]
        public objectQueries: Wars.Domain.Model.ObjectQuery[]
        public processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        public processTypes: Wars.Domain.Model.ProcessType[];
        
        constructor(
            public processConfigurationId: string,
            private securityMatrixService: services.SecurityMatrixService,
            private processConfigurationService: services.ProcessConfigurationService,
            private processTypeService: services.ProcessTypeService,
            private objectQueryService: services.ObjectQueryService,
            private systemLevelService: services.SystemLevelService)
        {
            this.securityMatricies = [];
            this.objectQueries = [];

            this.processConfigurationService.getById(processConfigurationId).then(p => {
                this.processConfiguration = p;
            });

            this.securityMatrixService.getProcessConfigurationSecurityMatrices(processConfigurationId)
                .then(processLevelSecurityMatricies => {
                    this.securityMatricies.addRange(processLevelSecurityMatricies);
                });

            this.systemLevelService.getSystemLevelSecurityMatrices()
                    .then(systemLevel => {
                        this.securityMatricies.addRange(systemLevel.mySecurityMatrices);
                });

            this.systemLevelService.getSystemLevelObjectQueries().then(systemLevel => {
                this.objectQueries.addRange(systemLevel.myObjectQueries);
            });

            this.objectQueryService.getProcessLevelObjectQueries(processConfigurationId).then((objectQueries) => {
                this.objectQueries.addRange(objectQueries);
            });

            this.processTypeService.getAllProcessTypes().then((processTypes) => {
                this.processTypes = processTypes;
            });
        }

        public save() {
            this.securityMatrixService.saveAllChanges();
        }
    }
}